import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

import { PeopleFeedbackBannerWrapper } from '../People/PeopleFeedbackBanner/styled';

export const ResourcesWrapper = styled.div`
  display: flex;
  flex-direction: row;

  padding-top: var(--navbar-height);

  background: linear-gradient(
    0deg,
    #f7f7f7 0%,
    rgba(223, 227, 238, 0.5) 50%,
    rgba(139, 157, 195, 0.5) 100%
  );

  ${BREAKPOINTS.mobile} {
    &[data-best-of-sidebar='true'] {
      padding-top: 64px;
    }

    &[data-best-of-sidebar='false'] {
      padding-top: 16px;
    }
  }

  ${PeopleFeedbackBannerWrapper} {
    max-width: 1440px;
    margin: 0 auto;
    background: rgba(59, 89, 152, 0.4);
    backdrop-filter: blur(10px);
  }
`;

export const ResourcesContainer = styled.div`
  width: 100%;
  max-width: calc(100% - var(--resource-sidebar-width));

  display: flex;
  flex-direction: row;
  justify-content: center;

  ${BREAKPOINTS.tablet} {
    max-width: unset;
    flex-direction: column;

    & > :not(:last-child) {
      margin-bottom: 32px;
    }
  }
`;

export const ResourcesDetailPageContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  padding: 34px 28px;
`;
